interface SectionTitleProps {
  title: string;
  subtitle?: string;
  actionText?: string;
  actionTo?: string;
}

import { Link } from 'react-router-dom';

export default function SectionTitle({ title, subtitle, actionText, actionTo }: SectionTitleProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-5">
      <div className="flex items-center gap-3">
        <span className="w-1 h-6 rounded-full bg-accent-500"></span>
        <div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 tracking-tight">{title}</h2>
          {subtitle && <p className="mt-0.5 text-sm text-foreground-500">{subtitle}</p>}
        </div>
      </div>
      {actionText && actionTo && (
        <Link
          to={actionTo}
          className="hidden sm:flex items-center gap-1 text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          {actionText}
          <i className="ri-arrow-right-line"></i>
        </Link>
      )}
    </div>
  );
}